import { render, staticRenderFns } from "./WarehouseTabReturn.vue?vue&type=template&id=f3783696&scoped=true"
import script from "./WarehouseTabReturn.vue?vue&type=script&lang=js"
export * from "./WarehouseTabReturn.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabReturn.vue?vue&type=style&index=0&id=f3783696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3783696",
  null
  
)

export default component.exports